import React from 'react'
import './Services.css'
import { IoCheckmarkDoneOutline } from "react-icons/io5";
import { RxDotFilled } from "react-icons/rx";

const Services = () => {
    return (
        <section id='services'>
            <h5 data-aos="fade-down"
                data-aos-easing="linear"
                data-aos-duration="650"
                data-aos-offset="170" >What I Offer</h5>
            <h2 data-aos="fade-down"
                data-aos-easing="linear"
                data-aos-duration="850"
                data-aos-offset="170">Service</h2>
            <div className="Econtainer">
                <div className="serv__container">
                    <div data-aos="fade-down"
                        data-aos-easing="linear"
                        data-aos-duration="500"
                        data-aos-offset="150">
                        <article className='service box-3'>
                            <div data-aos="fade-down"
                                data-aos-easing="linear"
                                data-aos-duration="500"
                                data-aos-offset="150" className="serv__head">
                                <h3>UI/UX Design</h3>
                            </div>

                            <ul data-aos="fade-up"
                                data-aos-easing="linear"
                                data-aos-duration="550"
                                data-aos-offset="280" className="serv__list">
                                <li>
                                    <IoCheckmarkDoneOutline className="serv__list-icon" />
                                    <p>
                                        Creative Web Designs. <br /> <small>(All Types Of Web Designs)</small>
                                    </p>
                                </li>

                                <li>
                                    <IoCheckmarkDoneOutline className="serv__list-icon" />
                                    <p>
                                        Responsive Desings. <br /> <small>Mobile, Tablet View</small>
                                    </p>
                                </li>

                                <li>
                                    <IoCheckmarkDoneOutline className="serv__list-icon" />
                                    <p>
                                        Creative Mobile App's Designs. <br /> <small>(Android, Ios)</small>
                                    </p>
                                </li>
                            </ul>
                        </article>
                    </div>
                    {/* -------------------END OF UI-DESIGN-------------------- */}
                    <div data-aos="fade-down"
                        data-aos-easing="linear"
                        data-aos-duration="650"
                        data-aos-offset="170">
                        <article className='service box-1' >
                            <div data-aos="fade-down"
                                data-aos-easing="linear"
                                data-aos-duration="500"
                                data-aos-offset="150" className="serv__head">
                                <h3>Flat Design</h3>
                            </div>
                            <ul data-aos="fade-up"
                                data-aos-easing="linear"
                                data-aos-duration="600"
                                data-aos-offset="300" className="serv__list">
                                <li>
                                    <IoCheckmarkDoneOutline className="serv__list-icon" />
                                    <h4>
                                        Visual Identity Design.
                                    </h4>
                                </li>
                                <li>
                                    <RxDotFilled className="serv__list-icon" />
                                    <p>
                                        Logo Design.
                                    </p>
                                </li>
                                <li>
                                    <RxDotFilled className="serv__list-icon" />
                                    <p>
                                        Social Media Interface <br /><small>(Profile Picture, Cover Picture).</small>
                                    </p>
                                </li>
                                <li>
                                    <RxDotFilled className="serv__list-icon" />
                                    <p>
                                        Print Advertising Design.
                                    </p>
                                </li>
                                <li>
                                    <RxDotFilled className="serv__list-icon" />
                                    <p>
                                        B-Card Design, <br /> <small>Brochure design.</small>
                                    </p>
                                </li>
                            </ul>
                        </article>
                    </div>

                    {/* -------------------END OF Print Media Design-------------------- */}
                    <div data-aos="fade-down"
                        data-aos-easing="linear"
                        data-aos-duration="800"
                        data-aos-offset="190">
                        <article className='service box-2 ' >
                            <div data-aos="fade-down"
                                data-aos-easing="linear"
                                data-aos-duration="500"
                                data-aos-offset="150" className="serv__head">
                                <h3>Web Development</h3>
                            </div>
                            <ul data-aos="fade-up"
                                data-aos-easing="linear"
                                data-aos-duration="650"
                                data-aos-offset="320" className="serv__list">
                                <li>
                                    <IoCheckmarkDoneOutline className="serv__list-icon" />
                                    <h4>
                                        Full Stack <small> Web Development</small>
                                        <br />
                                        <small>(All Types Of Websites).</small>
                                    </h4>
                                </li>
                                <li>
                                    <IoCheckmarkDoneOutline className="serv__list-icon" />
                                    <p>
                                        Responsive Websites Development
                                    </p>
                                </li>
                                <li>
                                    <RxDotFilled className="serv__list-icon" />
                                    <p>
                                        Business, landing Website
                                    </p>
                                </li>
                                <li>
                                    <RxDotFilled className="serv__list-icon" />
                                    <p>
                                        E - commerce Website
                                    </p>
                                </li>
                                <li>
                                    <RxDotFilled className="serv__list-icon" />
                                    <p>
                                        Portfolio, Personal Website
                                    </p>
                                </li>
                                <li>
                                    <RxDotFilled className="serv__list-icon" />
                                    <p>
                                        Educational, Media Website
                                    </p>
                                </li>
                            </ul>
                        </article>
                    </div>
                    {/* -------------------END OF FRONT-END-------------------- */}

                </div>
            </div >

        </section >

    )
}

export default Services